import {
  Button,
  BUTTON_VARIANT_PRIMARY,
  Modal,
  MODAL_SIZE_MD,
  ModalBody,
  ModalFoot,
  ModalHead
} from 'mailup-web-components'
import PropTypes from 'prop-types'

import { useIntl } from 'react-intl'

export const ModalStatistics = ({ show, handleCancel, handleConfirm }) => {
  const intl = useIntl()

  return (
    <Modal
      data-mu-test='modal-statistics-confirm'
      show={show}
      showClose
      onClose={handleCancel}
      closeOnOverlayClick
      size={MODAL_SIZE_MD}
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.TriggersList.ModalNoStatTitle'
        })}
      />
      <ModalBody>
        {intl.formatMessage({
          id: 'Load.TriggersList.ModalNoStatDescr'
        })}
      </ModalBody>
      <ModalFoot>
        <Button
          kind={BUTTON_VARIANT_PRIMARY}
          onClick={handleCancel}
          data-mu-test='button-confirm'
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Ok' })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

ModalStatistics.propTypes = {
  show: PropTypes.bool,
  handleCancel: PropTypes.func,
  handleConfirm: PropTypes.func
}
